import { Item } from '@radix-ui/react-radio-group';
import * as React from 'react';
import { cn } from '@discover-lib/utils';
import buttonVariants, { type ButtonVariantProps } from '@discover-ui/button/variants';

type ItemType = typeof Item;

export type RadioGroupButtonItemProps = React.ComponentPropsWithoutRef<ItemType> &
  ButtonVariantProps;

const RadioGroupButtonItem = React.forwardRef<
  React.ElementRef<ItemType>,
  RadioGroupButtonItemProps
>(({ className, kind = 'normal', round = false, scale = 'md', width, ...props }, ref) => (
  <Item
    ref={ref}
    className={cn(
      buttonVariants({
        kind,
        round,
        scale,
        width,
      }),
      'focus-visible:z-10',
      className
    )}
    {...props}
  />
));

RadioGroupButtonItem.displayName = 'RadioGroupButtonItem';

export default RadioGroupButtonItem;
